const loadFallbackRecs = async (containerEl) => {
  const url = containerEl.dataset.url;
  if (!url) return;

  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const sectionEl = doc.querySelector('.shopify-section');
    if (!sectionEl || !sectionEl.innerHTML.trim()) return;

    const headingOverride = containerEl.dataset.heading;
    const headingEl = sectionEl.querySelector('[data-complete-look-heading]');
    if (headingOverride && headingEl) {
      headingEl.textContent = headingOverride;
    }

    containerEl.innerHTML = sectionEl.innerHTML;
  } catch (err) {
    console.error('Error fetching complete the look recommendations:', err);
  }
};

const loadAcsRecs = (acsRecsEl) => {
  if (typeof window.graphenehc?.load !== 'function') {
    loadFallbackRecs(acsRecsEl);
    return;
  }

  window.graphenehc.load({
    elements: [{ id: 'pdp_recs_1', target: '[data-acs-complete-look-recs]' }],
    // NOTE: request `args` never reach element template renders (verified
    // 2026-07-27) — the heading override is applied client-side on success.
    // eslint-disable-next-line camelcase -- GrapheneHC API requires snake_case keys.
    page_context: { currency_id: window.Shopify.currency.active },
    success: () => {
      // The pdp_recs_1 template renders nothing when the element returns no
      // products — fall back to the S&D recommendations from data-url.
      if (!acsRecsEl.children.length) {
        loadFallbackRecs(acsRecsEl);
        return;
      }

      const headingOverride = acsRecsEl.dataset.heading;
      const headingEl = acsRecsEl.querySelector('h3');
      if (headingOverride && headingEl) headingEl.textContent = headingOverride;
    },
  });
};

const initCompleteLook = () => {
  const acsRecsEl = document.querySelector('[data-acs-complete-look-recs]');
  if (acsRecsEl) {
    if (acsRecsEl.dataset.recsLoaded === 'true') return;
    acsRecsEl.dataset.recsLoaded = 'true';
    loadAcsRecs(acsRecsEl);
    return;
  }

  const completeLookEl = document.querySelector('[data-complete-look]');
  if (!completeLookEl) return;
  if (completeLookEl.dataset.recsLoaded === 'true') return;
  completeLookEl.dataset.recsLoaded = 'true';
  loadFallbackRecs(completeLookEl);
};

export default initCompleteLook;
